export default [
  {
    title: '计划ID',
    key: 'planId',
    width: 60
  },
  {
    title: '计划名称',
    key: 'planName',
    width: 68
  },
  {
    title: '媒体',
    key: 'mediaName'
  },
  {
    title: '30日实际消耗金额',
    key: 'thirtyDaysAmount',
    width: 140
  },
  {
    title: '类型',
    key: 'type'
  }
]
